import React from 'react'
import PropTypes from 'prop-types'

import SegmentSelector, {
  InterestsSegmentSelector,
  GraduationYearSelector,
  EngagementStageSelector,
  FocusAndCareerSelector,
  ManualStudentSelector,
  LegalSexSection,
  LocationSelector,
  HighSchoolSegmentSelector,
  AcademicProfileSelector,
  DemographicsSelector,
} from 'components/SegmentSelector'
import { getIsUsingManualStudentSelection, getIsUsingMyMatches } from 'components/SegmentSelector/segment-service'
import { ONE_TIME_TRIGGER } from 'components/SegmentSelector/outreach-message-trigger-constants'
import FilterSegmentToggle from './FilterSegmentToggle'

const StudentSegmentation = ({ trigger, segment, onChange, onError }) => {
  const isOneTimeMessage = trigger === ONE_TIME_TRIGGER
  const isUsingMyMatches = getIsUsingMyMatches(segment)
  const isUsingManualStudentSelection = getIsUsingManualStudentSelection(segment)
  return (
    <SegmentSelector
      trigger={trigger}
      segment={segment}
      onChange={onChange}
    >
      {isUsingManualStudentSelection ? (
        <ManualStudentSelector />
      ) : (
        <FilterSegmentToggle>
          {isOneTimeMessage && !isUsingMyMatches && <EngagementStageSelector onError={onError} />}
          <GraduationYearSelector onError={onError} />
          <FocusAndCareerSelector />
          <InterestsSegmentSelector />
          <DemographicsSelector />
          <LegalSexSection/>
          <LocationSelector />
          <HighSchoolSegmentSelector />
          <AcademicProfileSelector />
        </FilterSegmentToggle>
      )}
    </SegmentSelector>
  )
}

StudentSegmentation.propTypes = {
  trigger: PropTypes.string,
  segment: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
}

export default StudentSegmentation
